// search-synonyms-en.js — Configuración del buscador para el locale EN.
// Espejo de search-synonyms.js. Se carga SOLO cuando request.locale.iso_code
// empieza con 'en' (ver layout/theme.liquid). Lo consume search-enhanced.js,
// que es compartido entre idiomas y no tiene ninguna rama por locale.
//
// NOTAS DE DISEÑO
//  • `typos` va VACÍO a propósito. El mapa español se derivó de búsquedas reales
//    del CSV; en inglés todavía no hay historial. Un typo inventado dispara el
//    banner de corrección y CAMBIA SILENCIOSAMENTE el query del usuario, así que
//    un falso positivo cuesta más que no corregir. Poblarlo cuando /en tenga
//    tráfico en el reporte de search terms de Shopify.
//  • No se porta `boostCategories` ni `minQueryLength`: son config muerta, nunca
//    se leen en search-enhanced.js.
//  • Los valores deben ser palabras que aparezcan en los títulos TRADUCIDOS del
//    catálogo. Si un producto no está traducido su título sigue en español y no
//    va a hacer match — ver cobertura de traducción antes de dar por buena esta
//    lista.

window.SearchConfig = {

  // ============================================================
  // Sinónimos — expansión OR de un solo término.
  // Cubre: singular↔plural, variantes US↔UK y sinónimos de categoría.
  // ============================================================
  synonyms: {

    // ── Vestidos ────────────────────────────────────────────
    'dress':        ['dresses'],
    'dresses':      ['dress'],
    'gown':         ['dress', 'maxi dress'],
    'maxi':         ['maxi dress', 'long dress'],
    'midi':         ['midi dress'],
    'mini':         ['mini dress', 'short dress'],
    'sundress':     ['dress', 'summer dress'],

    // ── Tops ────────────────────────────────────────────────
    'top':          ['tops'],
    'tops':         ['top'],
    'blouse':       ['blouses', 'top'],
    'blouses':      ['blouse', 'top'],
    'shirt':        ['shirts', 'blouse'],
    'shirts':       ['shirt', 'blouse'],
    't-shirt':      ['tshirt', 'tee', 'shirt'],
    'tshirt':       ['t-shirt', 'tee'],
    'tee':          ['t-shirt', 'tshirt'],
    'crop':         ['crop top'],
    'croptop':      ['crop top'],
    'tank':         ['tank top', 'camisole'],
    'camisole':     ['cami', 'tank top'],
    'cami':         ['camisole', 'tank top'],
    'bodysuit':     ['bodysuits', 'body'],
    'bodysuits':    ['bodysuit'],
    'halter':       ['halter top'],
    'corset':       ['bustier', 'corset top'],
    'bustier':      ['corset', 'corset top'],

    // ── Pantalones (US ↔ UK) ────────────────────────────────
    'pants':        ['trousers', 'pant'],
    'pant':         ['pants', 'trousers'],
    'trousers':     ['pants'],
    'trouser':      ['pants', 'trousers'],
    'jeans':        ['denim', 'jean'],
    'jean':         ['jeans', 'denim'],
    'denim':        ['jeans'],
    'leggings':     ['legging'],
    'legging':      ['leggings'],
    'joggers':      ['jogger', 'sweatpants'],
    'jogger':       ['joggers', 'sweatpants'],
    'sweatpants':   ['joggers'],
    'palazzo':      ['wide leg', 'palazzo pants'],
    'culottes':     ['wide leg', 'culotte'],
    'shorts':       ['short'],
    'short':        ['shorts'],

    // ── Faldas ──────────────────────────────────────────────
    'skirt':        ['skirts'],
    'skirts':       ['skirt'],
    'skort':        ['skirt', 'shorts'],

    // ── Exterior ────────────────────────────────────────────
    'jacket':       ['jackets'],
    'jackets':      ['jacket'],
    'blazer':       ['blazers', 'jacket'],
    'blazers':      ['blazer'],
    'coat':         ['coats', 'jacket'],
    'coats':        ['coat'],
    'cardigan':     ['cardigans', 'knit'],
    'cardigans':    ['cardigan'],
    'sweater':      ['sweaters', 'jumper', 'knit'],
    'sweaters':     ['sweater', 'jumper'],
    'jumper':       ['sweater', 'knit'],
    'knit':         ['sweater', 'knitwear'],
    'hoodie':       ['hoodies', 'sweatshirt'],
    'hoodies':      ['hoodie', 'sweatshirt'],
    'sweatshirt':   ['hoodie', 'sweater'],
    'vest':         ['vests', 'waistcoat'],
    'vests':        ['vest', 'waistcoat'],
    'waistcoat':    ['vest'],
    'trench':       ['trench coat', 'coat'],
    'puffer':       ['puffer jacket', 'jacket'],

    // ── Conjuntos y enterizos ───────────────────────────────
    'set':          ['sets', 'co-ord', 'matching set'],
    'sets':         ['set', 'co-ord'],
    'co-ord':       ['set', 'matching set'],
    'coord':        ['co-ord', 'set'],
    'jumpsuit':     ['jumpsuits', 'playsuit', 'romper'],
    'jumpsuits':    ['jumpsuit', 'romper'],
    'romper':       ['playsuit', 'jumpsuit'],
    'playsuit':     ['romper', 'jumpsuit'],
    'overall':      ['overalls', 'dungarees'],
    'overalls':     ['overall', 'dungarees'],
    'dungarees':    ['overalls'],

    // ── Accesorios y calzado ────────────────────────────────
    'bag':          ['bags', 'handbag', 'purse'],
    'bags':         ['bag', 'handbag'],
    'purse':        ['bag', 'handbag'],
    'handbag':      ['bag', 'purse'],
    'sneakers':     ['trainers', 'sneaker'],
    'sneaker':      ['sneakers', 'trainers'],
    'trainers':     ['sneakers'],
    'boots':        ['boot'],
    'boot':         ['boots'],
    'heels':        ['heel', 'pumps'],
    'sandals':      ['sandal'],
    'belt':         ['belts'],
    'scarf':        ['scarves'],

    // ── Atributos frecuentes ────────────────────────────────
    'long sleeve':  ['long sleeves'],
    'short sleeve': ['short sleeves'],
    'sleeveless':   ['no sleeve', 'tank'],
    'high waist':   ['high waisted', 'high rise'],
    'high waisted': ['high waist', 'high rise'],
    'off shoulder': ['off the shoulder'],
    'strapless':    ['tube', 'bandeau'],
    'ruffle':       ['ruffles', 'ruffled'],
    'ruffles':      ['ruffle', 'ruffled'],
    'pleated':      ['pleat', 'pleats'],
    'floral':       ['flower', 'flowers', 'print'],
    'striped':      ['stripes', 'stripe'],
    'oversized':    ['oversize', 'loose'],
    'bodycon':      ['fitted', 'tight'],
    'linen':        ['linen blend'],
    'satin':        ['silk', 'silky'],
    'lace':         ['laced'],
    'knitwear':     ['knit', 'sweater'],
    'basic':        ['basics'],
    'basics':       ['basic'],
  },

  // ============================================================
  // Typos — intencionalmente vacío. Ver nota de arriba.
  // ============================================================
  typos: {},

  // ============================================================
  // Colores — expansión palabra por palabra en queries multi-término.
  // PENDIENTE DE VERIFICAR contra el export de títulos EN: varios nombres de
  // color del catálogo son préstamos del inglés que probablemente sobrevivan
  // la traducción (camel, navy, stone, rust, sand, taupe, teal, sage, beige),
  // pero si Translate & Adapt dejó alguno en español habrá que apuntar ahí.
  // ============================================================
  colors: {
    'brown':      ['camel', 'chocolate', 'tan'],
    'camel':      ['brown', 'sand', 'tan'],
    'tan':        ['camel', 'sand', 'brown'],
    'beige':      ['stone', 'sand', 'nude'],
    'nude':       ['beige', 'stone'],
    'stone':      ['beige', 'taupe'],
    'taupe':      ['stone', 'grey', 'beige'],
    'sand':       ['beige', 'camel'],
    'khaki':      ['camel', 'olive', 'brown'],
    'rust':       ['terracotta', 'copper', 'brown'],
    'terracotta': ['rust', 'copper'],

    'red':        ['wine', 'burgundy'],
    'wine':       ['burgundy', 'red'],
    'burgundy':   ['wine', 'red'],
    'pink':       ['rose', 'fuchsia'],
    'rose':       ['pink'],
    'fuchsia':    ['pink', 'magenta'],
    'magenta':    ['fuchsia', 'pink'],
    'purple':     ['lilac', 'lavender'],
    'lilac':      ['purple', 'lavender'],
    'lavender':   ['lilac', 'purple'],

    'blue':       ['navy', 'sky'],
    'navy':       ['blue', 'marine'],
    'sky':        ['light blue', 'blue'],
    'turquoise':  ['aqua', 'teal'],
    'teal':       ['turquoise', 'aqua'],
    'aqua':       ['turquoise', 'teal'],

    'green':      ['olive', 'sage', 'emerald'],
    'olive':      ['green', 'khaki'],
    'sage':       ['green', 'mint'],
    'mint':       ['sage', 'green'],
    'emerald':    ['green'],
    'lime':       ['green'],

    'yellow':     ['mustard', 'gold'],
    'mustard':    ['yellow', 'gold'],
    'orange':     ['coral', 'terracotta'],
    'coral':      ['orange', 'pink'],

    'black':      ['negro'],
    'white':      ['ivory', 'cream', 'off white'],
    'ivory':      ['cream', 'white'],
    'cream':      ['ivory', 'off white'],
    'grey':       ['gray', 'stone'],
    'gray':       ['grey', 'stone'],
    'silver':     ['grey', 'metallic'],
    'gold':       ['golden', 'metallic'],
    'neutral':    ['beige', 'stone', 'grey'],
  },

  // Prefijos conversacionales que se eliminan del query ("show me X" → "X").
  // ORDEN IMPORTANTE: los más largos primero, la alternación del regex es
  // greedy-first ('search for' debe ganarle a 'search').
  queryPrefixes: [
    'looking for', 'searching for', 'search for', 'i want to see',
    'i want', 'i need', 'show me', 'give me', 'find me',
    'search', 'find', 'show',
  ],

  maxHistoryItems: 5,
  maxHistoryTermLen: 60,
  // Clave separada del español a propósito: quien cambia de idioma no debe ver
  // términos en español en el panel "Recent", que además generaría links
  // /en/search?q=vestidos con casi cero resultados.
  historyKey: 'hs-search-history-en',
};
